import { InvoicePayerType } from 'store/models/invoices';

export const FILTER_STATUS_SENDING = 'sending';
export const FILTER_STATUS_WAITING_DOC = 'WAITING_DOC';
export const FILTER_STATUS_NEW = 'NEW';
export const FILTER_STATUS_ENUM_SENDING = 'SENDING';

export const INVOICE_PAYER_TYPES_BANK = [InvoicePayerType.Legal, InvoicePayerType.Individual, InvoicePayerType.Natural];
